<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-6 banner-title">
            <span class="material-icons md-36" @click="closeQrCodeScanner()">keyboard_arrow_left</span>
            <span class="title-text" @click="closeQrCodeScanner()">{{ $t('message.checkout') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-50">
      <div
        v-if="accessBlocked"
        class="p-4 text-danger"
      >{{ $t('message.accessToCameraHasBeenBlocked') }}</div>
      <qrcode-stream :style="qrCodeFrame" class="qrcode-stream" @decode="onDecode"></qrcode-stream>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { QrcodeStream } from "vue-qrcode-reader";
export default {
  name: "CouponComponent",
  components: {
    QrcodeStream
  },
  props: {
    backToGiftCart: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      accessBlocked: false
    };
  },
  mounted() {
    this.openScanner();
  },
  computed: {
    ...mapGetters(["mobileStyles"]),
    qrCodeFrame() {
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      var height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      return `width:${width}px;
      height:${height}px;
      max-width:${width}px;
      max-height:${height}px;`;
    }
  },
  methods: {
    checkCameraPermission() {
      return navigator.mediaDevices.getUserMedia({ video: true });
    },

    onDecode(decodedString) {
      this.$router.push({
        name: "shoppingcartmobile",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
          qrcode: this.trim$(decodedString)
        }
      });
    },
    trim$(str) {
      if (str[0] == "$") {
        return str.substring(1);
      } else {
        return str;
      }
    },
    openScanner() {
      let that = this;
      window.setTimeout(function() {
        that.accessBlocked = true;
      }, 3000);
    },
    openQrCodeScanner() {},
    closeQrCodeScanner() {
      const target = this.backToGiftCart ? "giftshoppingcartmobile" : "shoppingcartmobile";
      this.$router.push({
        name: target,
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename
        }
      });
    }
  }
};
</script>
